<div class="agpr-alert-dashboard-bodyWrapper">
    @if (alertHistory) {
        <h2 class="agpr-alert-dashboard-title">
            {{ alertHistory.alertName }} - {{'Alerts.surge.dashboard.title.' + (alertHistory.metric || '') | localize}}
        </h2>

        <div class="agpr-alert-dashboard-dates">
            <span class="agpr-alert-dashboard-date">
                Date: <b>{{startTargetPeriod | date:'YYYY-MM-dd HH:mm'}}</b> to <b>{{endTargetPeriod | date:'YYYY-MM-dd HH:mm'}}</b>
            </span>
            @if (alertHistory.surgePercentageChangePositive > 0 || alertHistory.surgePercentageChangePositive === 0) {
                <div class="agpr-alert-dashboard-bubble">
                    <span
                        [agprTooltip]="'Alerts.surge.dashboard.tooltip.' + alertHistory.metric | localize:
                            {
                                alertName: alertHistory.alertName,
                                changeWord: (alertHistory.surgePercentageChangePositive >= 100 ?
                                    'Alerts.surge.dashboard.tooltip.increased' : 'Alerts.surge.dashboard.tooltip.decreased') | localize,
                                percent: alertHistory.surgePercentageChangePositive
                            }"
                    >
                        {{ (('Alerts.surge.metrics.' + alertHistory.metric +
                        (alertHistory.metric === alertSurgeMetrics.SENTIMENT ? '.positive' : '')) | localize) +
                        ' ' + alertHistory.surgePercentageChangePositive + '%'}}
                    </span>
                </div>
            }
            @if (alertHistory.surgePercentageChangeNegative > 0 || alertHistory.surgePercentageChangeNegative === 0) {
                <div class="agpr-alert-dashboard-bubble">
                    <span
                        [agprTooltip]="'Alerts.surge.dashboard.tooltip.negative.' + alertHistory.metric | localize:
                            {
                                alertName: alertHistory.alertName,
                                changeWord: (alertHistory.surgePercentageChangeNegative >= 100 ?
                                    'Alerts.surge.dashboard.tooltip.increased' : 'Alerts.surge.dashboard.tooltip.decreased') | localize,
                                percent: alertHistory.surgePercentageChangeNegative
                            }"
                    >
                        {{ (('Alerts.surge.metrics.' + alertHistory.metric +
                        (alertHistory.metric === alertSurgeMetrics.SENTIMENT ? '.negative' : '')) | localize) +
                        ' ' + alertHistory.surgePercentageChangeNegative + '%'}}
                    </span>
                </div>
            }
        </div>
    }

    @if (alertHistory?.impactfulDataChangeSinceSent || sourceChanged) {
        <div class="agpr-alert-dashboard-impactful">
            <agpr-message
                [severity]="messageSeverities.warning"
            >
                <div [innerHTML]="'Alerts.surge.dashboard.impactfulDataChangeSinceSent' | localize"></div>
            </agpr-message>
        </div>
    }

    <div
        #trendChartContainer
        class="agpr-alert-dashboard-container"
        [agprLoading]="loading"
    >
        <div class="agpr-alert-dashboard-exportMenu">
            <agpr-chart-export-menu
                [id]="'metric_trend_chart_export'"
                iconStyleClass="fa-regular fa-arrow-right-from-bracket"
                (exportMenuClicked)="chartExport($event, chart)"
            ></agpr-chart-export-menu>
        </div>
        @if (chart) {
            <agpr-reports-chart [chart]="chart"></agpr-reports-chart>
        }
    </div>
    <div
        class="agpr-alert-dashboard-container"
        [agprLoading]="loading"
    >
        <div class="agpr-alert-dashboard-exportMenu">
            <agpr-chart-export-menu
                [id]="'sentiment_trend_chart_export'"
                iconStyleClass="fa-regular fa-arrow-right-from-bracket"
                (exportMenuClicked)="chartExport($event, sentimentChart)"
            ></agpr-chart-export-menu>
        </div>
        @if (sentimentChart) {
            <!-- for the drill down, we want to add reports chart -->
            <agpr-reports-chart [chart]="sentimentChart"></agpr-reports-chart>
        }
    </div>
</div>
